import React, { useEffect, useState, useContext } from "react";
import { callAPI } from "utils/API";
import { Col, Row, Alert, Modal } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { AppContext } from "contexts/AppContext";
import Menu from "../../icons/Menu";
import Search from "../../icons/Search";
import Account2 from "../../icons/Account2";
import FavouriteBorder from "../../icons/FavouriteBorder";
import ShoppingCart from "../../icons/ShoppingCart";
import Headline6 from "components/elements/Headline6"
import ContentSmall from "components/elements/ContentSmall"
import { useNavigate } from "react-router-dom"
import ButtonMedium1 from "components/elements/ButtonMedium1";
import ButtonMedium4 from "components/elements/ButtonMedium4";
import Shop from "../../icons/shop";
import Drawer from "components/blocks/drawer/Drawer";
import Close from "components/icons/Close";
import Activity from "utils/Activity";
import { translate } from "utils/Translate";
import { pointsConvertor } from "utils/general";

function Header3(props) {
  const { style, className } = props
  const [show, setShow] = useState(false);
  const [showConfirmLogout, setShowConfirmLogout] = useState(false);
  const handleClose = () => setShow(false);
  const [shopURL, setShopURL] = useState(null);
  const [shopHeading, setShopHeading] = useState(null)
  const [teamAccess, setTeamAccess] = useState();
  const [announcements, setAnnouncements] = useState();
  const [hofURL, setHOFURL] = useState(null);
  const { brandData, menuData, styleGuide, userData, basket, setshowBasketQuickView, setStatusscroll, langCode } = useContext(AppContext);
  const brandLogoHeight = brandData && brandData.features && brandData.features.brandLogoHeight ? `${brandData.features.brandLogoHeight}px` : '35';
  const brandLogoWidth = brandData && brandData.features && brandData.features.brandLogoWidth ? `${brandData.features.brandLogoWidth}px` : 'auto';

  const navigate = useNavigate();

  const clearSession = () => {
    localStorage.clear()
    navigate('/logout')
  }

  const getTeamAccess = async () => {
    if (brandData?.features?.groupsHavingTeamMenuAccess?.length) {
      let groupNames = brandData.features.groupsHavingTeamMenuAccess
      let getAccess = await callAPI('/group/checkAccess', "GET", { query: { groupNames } });
      setTeamAccess(getAccess)
    }
}
  
  const getAnnouncements = async () => {
    let response = await callAPI('/announcements/web-pool', "GET");
    if(response?.length) {
      setAnnouncements(response)
    }
  } 
  
  useEffect(() => {
    getTeamAccess()
    getAnnouncements()
  }, [])

  useEffect(() => {
    if (menuData && !!menuData.length) {
      menuData.map((e, i) => {
        if (e.poolName.toLowerCase() === "shop") {
          let url = `/${e.poolName.toLowerCase()}`;
          if (!e.pool || e.pool.length === 0) return url;

          const key = Object.keys(e.pool[0]).find(
            (x) => x.toLowerCase() === `${e.poolName}ID`.toLowerCase()
          );
          setShopURL(`${url}/${e.pool[0][key]}`);
        }
        if (e.poolName.toLowerCase() === "halloffame") {
          let url = `/${e.poolName.toLowerCase()}`;
          if (!e.pool || e.pool.length === 0) return url;

          const key = Object.keys(e.pool[0]).find(
            (x) => x.toLowerCase() === `${e.poolName}ID`.toLowerCase()
          );
          setHOFURL(`${url}/${e.pool[0][key]}`);
        }
      });
    }
  }, [menuData])

  const ShopsMenu = () => {
    if (!menuData || !menuData.length) return null

    const shopMenuItem = menuData.filter(menu => menu.poolName.toLowerCase() === 'shop')
    if (!shopMenuItem || !shopMenuItem.length) return null
    
    const title = !!shopMenuItem[0] && !!shopMenuItem[0].translations && !!shopMenuItem[0].translations.length > 0
    ? shopMenuItem[0].translations.find(
      (translation) => translation.languageKey === langCode
      ) 
      ? shopMenuItem[0].translations.find(
        (translation) => translation.languageKey === langCode
    ).menuTitle
        : shopMenuItem[0].menuTitle
        : shopMenuItem[0].menuTitle

    setShopHeading(title || "Shop")

    const shops = shopMenuItem[0].pool
    if (shops.length === 1) {
      const link = `/shop/${shops[0].ShopID}`
      const title = shopMenuItem[0].menuTitle
      return <Nav.Link
        key='single-shop-link'
        style={menuItem}
        onClick={() => {
          handleClose();
          Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Shop',activityArgumentID: shops[0].ShopID})
          navigate(`${link}`);
        }}
      >
        {title}
      </Nav.Link>
    }
    if (shops.length > 1) {
      const menuItems = shops.map(shop => {
        const link = `/shop/${shop.ShopID}`
        const title = !!shop && !!shop.translations && !!shop.translations.length > 0
        ? shop.translations.find(
                (translation) => translation.languageKey === langCode
        ) 
        ? shop.translations.find(
            (translation) => translation.languageKey === langCode
        ).moduleName
            : shop.moduleName
        : shop.moduleName
        return <Nav.Link
          key={shop.ShopID}
          style={subMenuItem}
          onClick={() => {
            handleClose();
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Shop',activityArgumentID: shop.ShopID})
            navigate(`${link}`);
          }}
        >
          - {title}
        </Nav.Link>
      })

      return <>
        <Nav.Link
          key='shop-wrapper-link'
          style={menuItem}
        >
          {title}
        </Nav.Link>
        {menuItems}
      </>
    }
  }

  const NewsMenu = () => {
    if (!menuData || !menuData.length) return null

    const blogMenuItem = menuData.filter(menu => menu.poolName.toLowerCase() === 'blog')
    if (!blogMenuItem || !blogMenuItem.length) return null

    const blogs = blogMenuItem[0].pool
    const newsBlogs = blogs.filter(blog => blog.blogType === 'NEWS')

    if (!newsBlogs || !newsBlogs.length) return null

    if (newsBlogs.length === 1) {
      const link = '/posts'
      const title = !!blogMenuItem[0] && !!blogMenuItem[0].translations && !!blogMenuItem[0].translations.length > 0
      ? blogMenuItem[0].translations.find(
              (translation) => translation.languageKey === langCode
      ) 
      ? blogMenuItem[0].translations.find(
          (translation) => translation.languageKey === langCode
      ).menuTitle
          : blogMenuItem[0].menuTitle
      : blogMenuItem[0].menuTitle
      return <Nav.Link
        key='single-newsBlog-link'
        style={menuItem}
        onClick={() => {
          handleClose();
          Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Blog',activityArgumentID: ''})
          navigate(`${link}`);
        }}
      >
        {title}
      </Nav.Link>
    }

    if (newsBlogs.length > 1) {
      const menuItems = newsBlogs.map(blog => {
        const link = `/posts/${blog.BlogID}`
        const title = !!blog && !!blog.translations && !!blog.translations.length > 0
          ? blog.translations.find(
                  (translation) => translation.languageKey === langCode
          ) 
          ? blog.translations.find(
              (translation) => translation.languageKey === langCode
          ).moduleName
              : blog.moduleName
          : blog.moduleName
        return <Nav.Link
          key={blog.BlogID}
          style={subMenuItem}
          onClick={() => {
            handleClose();
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Blog',activityArgumentID: blog.BlogID})
            navigate(`${link}`);
          }}
        >
          - {title}
        </Nav.Link>
      })

      const title = !!blogMenuItem[0] && !!blogMenuItem[0].translations && !!blogMenuItem[0].translations.length > 0
      ? blogMenuItem[0].translations.find(
              (translation) => translation.languageKey === langCode
      ) 
      ? blogMenuItem[0].translations.find(
          (translation) => translation.languageKey === langCode
      ).menuTitle
          : blogMenuItem[0].menuTitle
      : blogMenuItem[0].menuTitle

      return <>
        <Nav.Link
          key='shop-wrapper-link'
          style={menuItem}
        >
          {title}
        </Nav.Link>
        {menuItems}
      </>
    }
  }

  const HOFMenu = () => {
    if (!menuData || !menuData.length) return null

    const hofMenuItem = menuData.filter(menu => menu.poolName.toLowerCase() === 'halloffame')
    if (!hofMenuItem || !hofMenuItem.length) return null

    const hofs = hofMenuItem[0].pool
    console.log(hofs)
    if (hofs.length === 1) {
      const link = `/halloffame/${hofs[0].HalloffameID}`
      const title = !!hofMenuItem[0] && !!hofMenuItem[0].translations && !!hofMenuItem[0].translations.length > 0
      ? hofMenuItem[0].translations.find(
              (translation) => translation.languageKey === langCode
      ) 
      ? hofMenuItem[0].translations.find(
          (translation) => translation.languageKey === langCode
      ).menuTitle
          : hofMenuItem[0].menuTitle
      : hofMenuItem[0].menuTitle
      return <Nav.Link
        key='single-shop-link'
        style={menuItem}
        onClick={() => {
          handleClose();
          Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Halloffame',activityArgumentID: hofs[0].HalloffameID})
          navigate(`${link}`);
        }}
      >
        {title}
      </Nav.Link>
    }
    if (hofs.length > 1) {
      const menuItems = hofs.map(hof => {
        const link = `/halloffame/${hof.HalloffameID}`
        const title = !!hof && !!hof.translations && !!hof.translations.length > 0
          ? hof.translations.find(
                  (translation) => translation.languageKey === langCode
          ) 
          ? hof.translations.find(
              (translation) => translation.languageKey === langCode
          ).moduleName
              : hof.moduleName
          : hof.moduleName
        return <Nav.Link
          key={hof.HalloffameID}
          style={subMenuItem}
          onClick={() => {
            handleClose();
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Halloffame',activityArgumentID: hof.HalloffameID})
            navigate(`${link}`);
          }}
        >
          - {title}
        </Nav.Link>
      })
      console.log(hofURL)

      const title = !!hofMenuItem[0] && !!hofMenuItem[0].translations && !!hofMenuItem[0].translations.length > 0
      ? hofMenuItem[0].translations.find(
              (translation) => translation.languageKey === langCode
      ) 
      ? hofMenuItem[0].translations.find(
          (translation) => translation.languageKey === langCode
      ).menuTitle
          : hofMenuItem[0].menuTitle
      : hofMenuItem[0].menuTitle

      return <>
        <Nav.Link
          key='shop-wrapper-link'
          style={menuItem}
          onClick={() => {
            Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Halloffame',activityArgumentID: ''})
            navigate(`${hofURL}`);
          }}
        >
          {title}
        </Nav.Link>
        {menuItems}
      </>
    }
  }
  
  const badgeStyle = {
    width: 17,
    height: 17,
    position: 'absolute',
    top: -10,
    right: -10,
    background: styleGuide.color16,
    padding: 0,
    margin: 0,
    lineHeight: 0,
    // textAlign: 'center',
    // verticalAlign: 'middle',
    borderRadius: 5,
    fontSize: '11px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  return (
    <>
      <div style={{position: "absolute", top: 0, zIndex: 1, width: "100%"}}>
        {
         announcements?.length ? announcements.map((announcement) => {
            return (
              <div key={announcement.AnnouncementID} style={{width: '100%', background: announcement.messageType === "INFO" ? styleGuide.color18 : announcement.messageType === "SYSTEM" ? styleGuide.color13 : styleGuide.color19, display: 'flex', alignItems: "center", height: 50, justifyContent: "center"}}>
                <marquee behavior={"scroll"} direction={"left"} style={{ color: "#ffffff", width: "80%",  fontWeight: "bold", textTransform: 'capitalize' }}>{announcement.message}</marquee>
              </div>
            )
          }):null
        }
      </div>
      <Container fluid style={{ ...HeaderPosition, ...style, top: !!announcements ? announcements.length * 50 : 0 }} className={className} >
          <Row style={{ lineHeight: "50px", height: '100%' }}>
            <Col lg={6} md={4} className="d-none d-sm-inline">
              <div style={headerLogo}>
                <img
                  style={{ height: `${brandLogoHeight}`, width: `${brandLogoWidth}`, cursor: 'pointer' }}
                  className="clubTopHeaderLogo"
                  src={brandData.brandLogo}
                  onClick={() => navigate('/')}
                />
              </div>
            </Col>
            <Col
              lg={6}
              md={8}
              style={{ paddingRight: 0, paddingLeft: 0 }}
              sm={12}
            >
              <Navbar bg={""} variant={""}>
                <Container className="containerFluidCustom">
                  <Navbar.Brand className="d-inline d-sm-none" style={{marginRight: 0}}>
                    <img
                      style={{ objectFit: "contain", cursor: 'pointer' }}
                      width={100}
                      height={60}
                      src={brandData.brandLogo}
                      onClick={() => navigate('/')}
                    />
                  </Navbar.Brand>
                  <Nav className="me-auto"></Nav>
                  <Nav>
                    <Navbar.Brand className="d-none d-sm-inline">
                      <span
                        style={{
                          color: styleGuide.color18,
                        }}
                        onClick={() => {
                          Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Profile',activityArgumentID: ''})
                          navigate('/profile')}}
                      >
                        <Account2 fill={styleGuide.color18} />
                      </span>
                      {brandData?.features?.points === false || !!brandData?.features?.hideUserPointBalance ? null : <span style={{ fontSize: 20, fontWeight: 500 }}>
                        {`${ pointsConvertor(brandData,userData.walletAmountPoints, translate('_HEADER_POINTS_', 'point'))}`}
                      </span>}
                    </Navbar.Brand>
                    <Nav.Link className="d-inline d-sm-none">
                      <span
                        style={{
                          ...iconCss,
                          color: styleGuide.color18,
                        }}
                        onClick={() => {
                          Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Profile',activityArgumentID: ''})
                          navigate('/profile')}}
                      >
                        <Account2 fill={styleGuide.color18} />
                      </span>
                  </Nav.Link>
                 {teamAccess && <Nav.Link
                    title="Team"
                    onClick={() => {
                        Activity({ activityType: 'click', activityName: 'header', activityArgument: 'Team', activityArgumentID: '' })
                        navigate('/team')
                    }}
                    className="d-sm-inline"
                  >
                    <span
                      style={{
                        ...iconCss,
                        color: styleGuide.color1,
                        fontWeight: '500',
                        fontSize: '20px'
                      }}
                    >
                      Team
                    </span>
                  </Nav.Link>}
                    <Nav.Link
                      title="Shop"
                      onClick={() => navigate(shopURL)}
                      className="d-sm-inline"
                    >
                      <span
                        style={{
                          ...iconCss,
                          color: styleGuide.color18,
                          fontWeight: '500',
                          fontSize: '20px'
                        }}
                      >
                        {shopHeading}
                      </span>
                    </Nav.Link>
                    {
                      !brandData?.features?.disableWishlist &&
                      <Nav.Link
                        onClick={() => {
                          Activity({activityType: 'click',activityName: 'header',activityArgument: 'Wishlist',activityArgumentID: ''})
                          navigate('/profile/wishlist')}}
                        className="d-none d-sm-inline"
                      >
                        <span
                          style={{
                            ...iconCss,
                            color: styleGuide.color18,
                          }}
                        >
                          <FavouriteBorder fill={styleGuide.color18} />
                        </span>
                      </Nav.Link>
                    }
                    {brandData && brandData.features && brandData.features.cartIcon === false ? null :
                    <Nav.Link
                      onClick={(e) => {
                        e.stopPropagation()
                        setshowBasketQuickView(true)
                      }}
                      className="d-sm-inline"
                    >
                      <span
                        style={{
                          ...iconCss,
                          color: styleGuide.color18,
                          position: 'relative'
                        }}
                      >
                        <ShoppingCart fill={styleGuide.color18} />
                        {basket.length ? <div style={badgeStyle}>{basket.length}</div> : null}
                      </span>
                    </Nav.Link>}
                    <Nav.Link onClick={() => {
                      Activity({activityType: 'click',activityName: 'header',activityArgument: 'Search',activityArgumentID: ''})
                      navigate('/search')}}>
                      <span
                        style={{
                          ...iconCss,
                          color: styleGuide.color18,
                        }}
                      >
                        <Search fill={styleGuide.color18} />
                      </span>
                    </Nav.Link>
                    <Nav.Link eventKey={2} onClick={(e) => {
                        e.stopPropagation()
                        setShow(true)
                        }}>
                      <span
                        style={{
                          color: styleGuide.color18,
                        }}
                      >
                        <Menu fill={styleGuide.color18} />
                      </span>
                    </Nav.Link>
                  </Nav>
                </Container>
              </Navbar>
              <Drawer visible={show} closeHandler={handleClose}>
                <div style={{ ...menuPosition, paddingRight: 40, minHeight: !!announcements && announcements.length ? '110vh' : '100vh', display: 'flex', flexDirection: 'column' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: 20 }}>
                    <Close fill={styleGuide.color7} onClick={() => handleClose()} style={{ cursor: 'pointer' }} />
                  </div>
                  <div>
                    <p style={{ fontSize: "14px" }}>Menu</p>
                    <NewsMenu />
                    <ShopsMenu />
                    <HOFMenu />
                  </div>

                  <div style={{ paddingTop: "5vw", marginTop: 100, marginBottom: 50 }}>
                    <p style={{ fontSize: "14px", lineHeight: '18px' }}>
                      {
                        translate(
                          "_MENU_OTHER_LINKS_CAPTION_",
                          "Andet"
                        )
                      }
                    </p>
                    <Nav.Link
                      style={subMenuItem}
                      href="#"
                      onClick={() => {
                        Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Profile',activityArgumentID: ''})
                        navigate('/profile')}}
                    >
                      {
                        translate(
                          "_MENU_MY_PROFILE_",
                          "Din profil"
                        )
                      }
                    </Nav.Link>
                    <Nav.Link
                      style={subMenuItem}
                      href="#"
                      onClick={() => { handleClose(); setStatusscroll(true);  Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Profile',activityArgumentID: ''})
                      navigate('/profile')}}
                    >
                      {
                        translate(
                          "_MENU_PROFILE_SETTINGS_",
                          "Indstillinger"
                        )
                      }
                    </Nav.Link>
                    {brandData && brandData.features && brandData.features.claims && <Nav.Link
                      style={subMenuItem}
                      href="#"
                      onClick={() => {
                        Activity({activityType: 'click',activityName: 'menu',activityArgument: 'Report',activityArgumentID: ''})
                        navigate('/indberetning')}}
                    >
                      {
                        translate(
                          "_MENU_REPORTING_",
                          "Indberetning"
                        )
                      }
                    </Nav.Link>}
                    <Nav.Link
                      style={subMenuItem}
                      href="#"
                      onClick={() => { handleClose(); 
                        Activity({activityType: 'click',activityName: 'help',activityArgument: 'Contact',activityArgumentID: ''})
                        navigate("/help", {state:{scrollToContact:true}}) }}
                    >
                      {
                        translate(
                          "_MENU_CONTACT_",
                          "Kontakt"
                        )
                      }
                    </Nav.Link>
                    <Nav.Link
                      style={subMenuItem}
                      href="#"
                      onClick={() => { handleClose(); 
                        Activity({activityType: 'click',activityName: 'help',activityArgument: 'FAQ',activityArgumentID: ''})
                        navigate("/help",{state:{scrollToFaq:true}}) }}
                    >
                      FAQ
                    </Nav.Link>
                    <Nav.Link style={subMenuItem} href="#" onClick={() => setShowConfirmLogout(true)}>
                    {
                      translate(
                        "_MENU_LOG_OUT_",
                        "Log ud"
                      )
                    }
                    </Nav.Link>
                  </div>
                </div>
              </Drawer>
            </Col>
          </Row>
      </Container>
      <Modal show={showConfirmLogout} onHide={() => setShowConfirmLogout(false)} style={{ margin: 'auto' }} centered>
        <Modal.Header className="pb-0 border-0" closeButton style={{ fontSize: 9 }}>
          <Headline6 translationKey="_CONFIRM_LOGOUT_">Bekræft log ud </Headline6>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <ContentSmall translationKey="_CONFIRM_LOGOUT_TEXT_">Er du sikker på at du vil logge ud? </ContentSmall>
          <div style={{
            display: 'flex',
            padding: '1rem',
            justifyContent: 'space-around',
          }}>
            <ButtonMedium1 showIcon={false} translationKey="_YES_" fallbackText="Ja" onClick={() => clearSession()} />
            <ButtonMedium4 showIcon={false} translationKey="_NO_" fallbackText="Nej" onClick={() => setShowConfirmLogout(false)} />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

const HeaderPosition = {
  // position: "absolute",
  // top: 0,
  height: "100px",
  display: "flex",
  flexDirection: "column",
};

const menuPosition = {
  paddingBottom: "20px",
  paddingLeft: "50px",
  paddingTop: "30px",
};

const menuItem = {
  fontWeight: "600",
  padding: "4px 0px",
  color: "black",
  fontSize: "30px",
  lineHeight: '45px'
};

const subMenuItem = {
  fontSize: "18px",
  fontWeight: "600",
  padding: "2px 0px",
  color: "black",
  lineHeight: '28px'
};

const iconCss = {
  marginRight: "8px",
};

const headerLogo = {
  margin: "16px 80px",
};
export default Header3;
